// import React from "react";
// import {
//     Box,
//     Checkbox,
//     Stack,
//     Typography,
//     useTheme,
// } from "@mui/material";

// interface LegalCardProps {
//     checked: boolean;
//     title: string;
//     description: string;
//     icon: React.ReactNode;
//     onChange: (checked: boolean) => void;
//     link?: React.ReactNode;
//     tag?: string;
// }

// const LegalCard: React.FC<LegalCardProps> = ({
//     checked,
//     title,
//     description,
//     icon,
//     onChange,
//     link,
//     tag,
// }) => {
//     const theme = useTheme();

//     return (
//         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2, borderRadius: 2, bgcolor: "rgba(0,0,0,0.022)" }}>
//             <Stack direction="row" alignItems="center" spacing={2} sx={{ flex: 1, minWidth: 0 }}>
//                 <Checkbox
//                     checked={checked}
//                     onChange={(e) => onChange(e.target.checked)}
//                     sx={{ color: theme.palette.text.primary, "&.Mui-checked": { color: theme.palette.primary.main } }}
//                 />
//                 <Box sx={{ minWidth: 0, flex: 1 }}>
//                     <Stack direction="row" alignItems="center" spacing={1}>
//                         <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
//                             {title}
//                         </Typography>
//                         {tag &&
//                             <Typography variant="caption" sx={{ color: theme.palette.text.secondary, bgcolor: "rgba(0,0,0,0.05)", px: 1, borderRadius: 1, fontSize: "9px", fontWeight: 600 }}>
//                                 {tag}
//                             </Typography>
//                         }
//                     </Stack>
//                     <Typography variant="body2" sx={{ fontSize: "12px", mt: 0.5, color: theme.palette.text.secondary }}>
//                         {description}
//                     </Typography>
//                 </Box>
//             </Stack>
//             <Box sx={{ width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center" }}>
//                 {icon}
//             </Box>
//             {link &&
//                 <Box>
//                     {link}
//                 </Box>
//             }
//         </Box>
//     );
// };

// export default LegalCard;

import React from "react";
import {
    Box,
    Checkbox,
    Stack,
    Typography,
    useTheme,
} from "@mui/material";

interface LegalCardProps {
    checked: boolean;
    title: string;
    description: string;
    icon: React.ReactNode;
    onChange: (checked: boolean) => void;
    link?: React.ReactNode;
    tag?: string;
    disabled?: boolean;        // Nueva prop
    hideCheckbox?: boolean;    // Nueva prop
}

const LegalCard: React.FC<LegalCardProps> = ({
    checked,
    title,
    description,
    icon,
    onChange,
    link,
    tag,
    disabled = false,
    hideCheckbox = false,
}) => {
    const theme = useTheme();

    return (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", p: 2, borderRadius: 2, bgcolor: "rgba(0,0,0,0.022)" }}>
            <Stack direction="row" alignItems="center" spacing={2} sx={{ flex: 1, minWidth: 0 }}>
                {!hideCheckbox && (
                    <Checkbox
                        checked={checked}
                        onChange={(e) => onChange(e.target.checked)}
                        disabled={disabled}
                        sx={{
                            color: theme.palette.text.primary,
                            "&.Mui-checked": { color: theme.palette.primary.main },
                            "&.Mui-disabled": { color: theme.palette.action.disabled }
                        }}
                    />
                )}
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                            {title}
                        </Typography>
                        {tag &&
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, bgcolor: "rgba(0,0,0,0.05)", px: 1, borderRadius: 1, fontSize: "9px", fontWeight: 600 }}>
                                {tag}
                            </Typography>
                        }
                    </Stack>
                    <Typography variant="body2" sx={{ fontSize: "12px", mt: 0.5, color: theme.palette.text.secondary }}>
                        {description}
                    </Typography>
                </Box>
            </Stack>
            <Box sx={{ width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center" }}>
                {icon}
            </Box>
            {link &&
                <Box>
                    {link}
                </Box>
            }
        </Box>
    );
};

export default LegalCard;